<script setup lang="ts">
import { computed } from 'vue';

import { useGenerateIds } from '../composables';
import type { FileUploadResult } from './blueimp-file-upload';

//simulate old {% box %} macro, but only handle either both classes (horizontal) or none (vertical, inline)
const props = defineProps<{
    hideDetails?: boolean;
    hideClose?: boolean;
    result?: FileUploadResult;
}>();

const generateIds = useGenerateIds();

const detailsId = generateIds();
const stats = computed(() => props.result?.stats ?? {});
const status = computed(() => {
    const stats0 = props.result?.stats;
    if(!stats0) return '';
    if(stats0.feerrors || stats0.fedenied || ((stats0.feimporting !== undefined) && (stats0.feimporting != stats0.feimported))) {
        return 'text-danger';
    } else if(stats0.feduplicates) {
        return 'text-warning';
    }
    return 'text-success';
});

</script>
<template>
    <div class="form-horizontal">
        <div class="form-group">
            <div v-if="stats?.processed && stats?.files" class="col-sm-12">
                <p class="log-line" :class="status">
                    {{ `elaborati ${stats.processed}/${stats.files} file` }}
                </p>
                <p class="log-line" :class="status">
                    risultati:
                </p>
                <p v-if="stats.feerrors !== undefined" class="log-line" :class="(stats.feerrors ? 'text-danger' : '')">
                    errori: {{ stats.feerrors }}
                </p>
                <p v-if="stats.fedenied !== undefined" class="log-line" :class="(stats.fedenied ? 'text-danger' : '')">
                    accesso negato: {{ stats.fedenied }}
                </p>
                <p v-if="stats.feduplicates !== undefined" class="log-line" :class="(stats.feduplicates ? 'text-warning' : '')">
                    duplicati: {{ stats.feduplicates }}
                </p>
                <p v-if="stats.fewarnings !== undefined" class="log-line" :class="(stats.fewarnings ? 'text-warning' : '')">
                    allarmi: {{ stats.fewarnings }}
                </p>
                <p
                    v-if="stats.feimporting !== undefined"
                    class="log-line"
                    :class="((stats.feimporting == stats.feimported) ? 'text-success' : 'text-danger')"
                >
                    da importare: {{ stats.feimporting }}
                </p>
                <p
                    v-if="stats.feimported !== undefined"
                    class="log-line"
                    :class="(((stats.feimporting === undefined) || (stats.feimporting == stats.feimported)) ? 'text-success' : 'text-danger')"
                >
                    importati: {{ stats.feimported }}
                </p>
                <p v-if="stats.fetotal !== undefined" class="log-line">
                    totale: {{ stats.fetotal }}
                </p>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-6">
                <button
                    v-if="!props.hideDetails"
                    type="button"
                    class="btn btn-default"
                    data-toggle="collapse"
                    :data-target="`#${detailsId}`"
                >
                    Mostra dettagli
                </button>
            </div>
            <div class="col-sm-6">
                <div class="pull-right">
                    <slot name="buttons">
                        <button v-if="!props.hideClose" type="button" class="btn btn-primary" data-dismiss="modal">
                            Esci
                        </button>
                    </slot>
                </div>
            </div>
        </div>
        <div v-if="!props.hideDetails" :id="detailsId" class="collapse form-group">
            <div class="col-sm-12" style="height: 20em; overflow: scroll;">
                <pre style="display: inline-block; border: 0 hidden;">
                    {{ props.result?.log ?? '' }}
                </pre>
            </div>
        </div>
    </div>
</template>
